export default __webpack_public_path__ + "assets/img/document-editor.bed72ac36d526bc69eac4d62ea52eb44.png";